import { get, post } from '@/utils/request1';

export const consumptionList = (data) => post('orderw/money_log',data); // 消费流水
export const creditList = (data) => post('orderw/credit_log',data); // 信用流水
export const invoiceList = (data) => post('order/index',data); // 发票列表

export const consumptionExport = (data) => post('orderw/recharge_export',data); // 消费流水导出
export const creditExport = (data) => post('orderw/credit_log_export',data); // 信用流水导出